import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { useTranslation } from 'react-i18next'

import { ReactComponent as CircleIcon } from '../../assets/icons/chipCircle.svg'

import { CHIP_COLORS } from '../../constants/other'

import useStyles from './styles'

export const defaultColor = CHIP_COLORS.neutral

function Chip(props) {
  const { t } = useTranslation()

  const {
    text = '',
    color = defaultColor,
    subTagColor = defaultColor,
    className = '',
    subTag,
    isBadge,
    isSmall = false,
    isHoverable,
    showCircle = true,
    isBackgroundTransparent,
    ...restProps
  } = props
  const classes = useStyles({ color, subTagColor, isBadge, isSmall, isHoverable, isBackgroundTransparent })

  return (
    <div className={classes.tagWrapper}>
      <div className={classnames(classes.tag, className, { withSubTagSeparator: !!subTag })} {...restProps}>
        <div className={classes.tagContent}>
          {showCircle && <CircleIcon />}
          {t(text)}
        </div>
      </div>
      {subTag && (
        <div className={classnames(classes.subTag, className)} {...restProps}>
          {subTag}
        </div>
      )}
    </div>
  )
}

Chip.propTypes = {
  text: PropTypes.string.isRequired,
  color: PropTypes.string,
  subTagColor: PropTypes.string,
  className: PropTypes.string,
  subTag: PropTypes.string,
  isBadge: PropTypes.bool,
  isSmall: PropTypes.bool,
  isHoverable: PropTypes.bool,
  showCircle: PropTypes.bool
}

export default Chip
